// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"538":"recorder","983":"profiler"}[chunkId] + "." + {"538":"f1b7aed4","983":"8fe9cd8d"}[chunkId] + ".chunk.js";
};